import { getOrderShowtimes } from '../showtimes/get-order-showtimes';
/**
 * Returns the currently selected tickets, organised by showtimeId.
 *
 * Overrides the selections for the currently in-progress showtime.
 */
export const getOrderTicketsPerShowtime = () => {
    const ticketsByShowtimeId = new Map();
    getOrderShowtimes().forEach(showtime => {
        ticketsByShowtimeId.set(showtime.showtimeId, showtime.tickets);
    });
    return ticketsByShowtimeId;
};
//# sourceMappingURL=get-order-tickets-per-showtime.js.map